// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JPUwA","largestCol":"styles_largestCol__3YLn-","smallestCol":"styles_smallestCol__2m-mZ"};